import { MoleMeta, NftDetails } from 'views/VvsMinerMoleMyMoles/types'

export type PageLimitation = 10 | 25 | 50 | 100 | 120 // available page limitation

export const AVAILABLE_LIMIT: Record<string, PageLimitation> = {
  '10': 10,
  '25': 25,
  '50': 50,
  '100': 100,
  '120': 120,
}

export type FilterType = 'legendary' | ''

export type SortType = 'id' | ''

export type OrderType = 'asc' | 'des'

export type Filter = {
  limit: PageLimitation
  page: number
  sort?: SortType
  order?: OrderType
  filter?: FilterType
  id?: number | ''
}
export interface MoleListMeta {
  data: MoleMeta[]
  page: number
  total: number
  totalPages: number
  availableLimit: ReadonlyArray<number>
}

export interface MoleListDetails extends Omit<MoleListMeta, 'data'> {
  data: NftDetails[]
}
